import { IconButton } from '@mui/material';
import { FC, useCallback } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
  notificationsActions,
  notificationSelectors,
  useAppDispatch,
  useAppSelector,
} from '@vs-online-only-app/state';
import { SnackAlert } from '@vs-online-only-app/ui';

const SnackNotifier: FC = () => {
  const currentNotification = useAppSelector(
    notificationSelectors.selectCurrentNotification,
  );
  const dispatch = useAppDispatch();
  const isOpen = !!currentNotification;

  const handleClose = useCallback(() => {
    dispatch(notificationsActions.setCurrentNotification(undefined));
  }, [dispatch]);

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  if (!currentNotification) return null;

  return (
    <SnackAlert
      action={action}
      handleClose={handleClose}
      open={isOpen}
      {...currentNotification}
    />
  );
};

export default SnackNotifier;
